export const appUrl = () => `${window.location.origin}${process.env.ASSET_PATH}`.replace(/\/$/, '');
